import { useNavigate } from 'react-router-dom';
import { AdminShell, ProductGrid } from '../../../components';
import { useAdminProductsLogic } from './logic';
import constant from '../../../utils/constant';

export const Products = () => {
	const {
		isLoadingProducts,
		isFetchingProduct,
		onProductLimitChange,
		productLimit,
		currentProductPage,
		setCurrentProductPage,
		setSearchProductQuery,
		productGridData,
		totalProductCounts,
	} = useAdminProductsLogic();
	const navigate = useNavigate();

	return (
		<AdminShell
			pageTitle={'Products'}
			actionButton={{
				title: 'Add Product',
				onClick: () => navigate(constant.Routes.Admin.AddProduct),
			}}>
			<ProductGrid
				products={productGridData}
				searchPlaceholder="Search Products"
				searchVariant="wide"
				totalItems={totalProductCounts}
				onLimitChange={onProductLimitChange}
				isLoading={isLoadingProducts}
				isFetching={isFetchingProduct}
				limit={productLimit}
				currentPage={currentProductPage}
				setCurrentPage={setCurrentProductPage}
				setSearchQuery={setSearchProductQuery}
				emptyMessage="No Products found or match search"
			/>
		</AdminShell>
	);
};

export default Products;
